export function isNullOrEmptyGuid(guid: string | undefined | null): boolean {
  return !(guid && guid !== '00000000-0000-0000-0000-000000000000');
}

export function isValidGuid(guid: string | undefined | null): boolean {
  return /^[0-9a-f]{8}-([0-9a-f]{4}-){3}[0-9a-f]{12}$/.test(guid!);
}
